import React from 'react';
import { GenericRadio } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';

const Registration = ({ values }) => (
  <Content>
    {({
      initialQuestionsRegistrationLabel,
      initialQuestionsRegistrationYes = '',
      initialQuestionsRegistrationNo = '',
      holdMoneyText = ''
    }) => (
      <Field name="registration" subscription={{ touched: true, error: true }}>
        {({ input }) => (
          <GenericFieldWrapper
            inputId="registration"
            title={initialQuestionsRegistrationLabel}
            description={holdMoneyText}
          >
            <GenericRadio.InlineSet
              groupName="registration-group"
              items={[
                {
                  id: initialQuestionsRegistrationYes,
                  labelText: initialQuestionsRegistrationYes
                },
                {
                  id: initialQuestionsRegistrationNo,
                  labelText: initialQuestionsRegistrationNo
                }
              ]}
              {...input}
              selectedId={values.registration}
            />
          </GenericFieldWrapper>
        )}
      </Field>
    )}
  </Content>
);

export default Registration;
